import _ from 'lodash';
import { createSelector } from 'reselect';

import { StoreState } from '../../redux/reducers/store.types';
import { getRouteParams } from '../../router/router.selectors';
import { Organization } from '../../types/entities';

const getAllOrganizations = (state: Pick<StoreState, 'organization'>) =>
  state.organization.organizations;

const getOrganizationsMemberships = (state) =>
  _.get(state, 'session.userInfo.memberships');

export const getInvitations = (state) => state.organization.invitations;

export const getOrganizations = createSelector(
  getAllOrganizations,
  getOrganizationsMemberships,
  (organizations, memberships) => _.merge({}, organizations, memberships),
);

export const getSelectedOrganization = createSelector(
  getAllOrganizations,
  getRouteParams,
  (organizations, routeParams): Organization =>
    organizations[_.get(routeParams, 'organizationId')],
);

export const getSelectedOrganizationId = createSelector(
  getSelectedOrganization,
  (organization: Organization): string => _.get(organization, 'id'),
);

export const getSelectedOrganizationName = createSelector(
  getSelectedOrganization,
  (organization) => _.get(organization, 'name'),
);

export const getCurrentOrganizationOwnerId = createSelector(
  getSelectedOrganization,
  (organization: Organization) => _.get(organization, 'ownerId'),
);

export const getOrganizationNameById = createSelector(
  getAllOrganizations,
  (organizations) =>
    _.memoize((organizationId: string) => {
      const organization = _.find(organizations, { id: organizationId });
      return _.get(organization, 'name');
    }),
);

export const hasOwnOrganizations = createSelector(
  getAllOrganizations,
  (organizations) => !_.isEmpty(organizations),
);

export const hasInvitations = createSelector(
  getInvitations,
  (invitations) => !_.isEmpty(invitations),
);
